import { Box, Typography } from "@mui/material";

export function SectionHeading({ overline, title, subtitle, component = "h2", align = "center" }) {
  return (
    <Box sx={{ textAlign: align, maxWidth: 680, mx: align === "center" ? "auto" : 0, mb: { xs: 5, md: 8 } }}>
      {overline && (
        <Typography variant="overline" component="p" sx={{ color: "primary.main", mb: 2 }}>
          {overline}
        </Typography>
      )}

      <Typography variant="h2" component={component} sx={{ fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" } }}>
        {title}
      </Typography>

      {subtitle && (
        <Typography sx={{ mt: 2, color: "text.secondary", fontSize: { xs: "1rem", md: "1.125rem" }, lineHeight: 1.7 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
